// extracted by mini-css-extract-plugin
export default {"card":"card__-35821a9","row":"row__-35821a9"};